<template>
  <modal
    name="offer-modal"
    :resizable="true"
    :height="'auto'"
    :width="'80%'"
    :scrollable="true"
  >
    <!-- Modal formularza danych klienta -->
    <div v-if="showClientForm" class="client-form-overlay" @click.self="cancelClientForm">
      <div class="client-form-modal">
        <div class="client-form-header">
          <h4>📋 Dane klienta</h4>
          <button class="btn-close-form" @click="cancelClientForm">✕</button>
        </div>
        <div class="client-form-body">
          <div class="form-field">
            <label>Nazwa klienta / Email *</label>
            <input 
              v-model="clientData.nameOrEmail" 
              type="text" 
              placeholder="Wprowadź nazwę klienta lub adres email"
              @keyup.enter="submitClientForm"
              ref="clientNameInput"
            />
          </div>
          <div v-if="needPdfFilename" class="form-field">
            <label>Nazwa pliku PDF *</label>
            <input 
              v-model="clientData.pdfFilename" 
              type="text" 
              placeholder="Wprowadź nazwę pliku PDF"
              @keyup.enter="submitClientForm"
            />
          </div>
        </div>
        <div class="client-form-footer">
          <button class="btn-form-cancel" @click="cancelClientForm">
            Anuluj
          </button>
          <button class="btn-form-submit" @click="submitClientForm">
            {{ needPdfFilename ? 'Generuj PDF' : 'Zapisz ofertę' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Nagłówek modalu -->
    <div class="modal-header-custom">
      <div class="header-content">
        <h3 class="modal-title">📄 Podgląd oferty</h3>
        <p class="modal-subtitle" v-if="offerNumber">{{ offerNumber }}</p>
      </div>
      <button class="btn-close-modal" @click="$emit('closeModal')">
        ✕
      </button>
    </div>

    <!-- Treść oferty (do druku PDF) -->
    <div class="modal-content-custom">
    <div id="toPrint" class="mx-3">
      <div class="row">
        <img src="../assets/logo.png" alt="" />
      </div>
      <div class="row text-right">
        <div class="col-12">
          <p>
            ul. Wąska 4 Zaborze, 43-520 Chybie <br />
            biuro@klim-bud.pl <br />
            tel: 574 559 890
            <br />
            NIP:548-235-02-89<br />
            REGON: 241002771 <br />
            www.klim-bud.pl
          </p>
        </div>
      </div>
      <div class="row text-right">
        <div class="col-12 my-4 mb-3">Chybie dn. {{ date.toLocaleDateString("pl") }}</div>
      </div>
      <div class="row my-4 text-center">
        <div class="col-12">
          <h3 class="my-4">OFERTA CENOWA</h3>
          <h5>{{ offerNumber }}</h5>
          <br /><br />
          <h5 class="my-4" v-html="header2">
            {{ header2 }}
          </h5>
          <br />
          <p class="my-4" v-html="subheader">
            {{ subheader }}
          </p>
        </div>
      </div>

      <div class="html2pdf__page-break"></div>

      <div class="row">
        <img src="../assets/logo.png" alt="" />
      </div>

      <!-- <div class="row text-right">
        <div class="col-12">
          <p>
            ul. Wąska 4 Zaborze, 43-520 Chybie <br />
            biuro@klim-bud.pl <br />
            tel: 504 041 946
            <br />
            NIP:548-235-02-89<br />
            REGON: 241002771 <br />
            www.klim-bud.pl
          </p>
        </div>
      </div> -->

      <div class="row text-center">
        <div class="col-12 my-5">
          <h5 v-html="offerHeader">{{ offerHeader }}</h5>
        </div>

        <!-- <div class="row">
          <div class="col-12 text-center">
            <img style="max-height: 500px" :src="`${imageUrl}`" alt="" />
          </div>

          <div class="col-3 ml-5 text-center border">
            <small>Uwagi do oferty:</small> <br />
            {{ notice }}
          </div>
        </div> -->

        <table style="font-size: 14px" class="table mt-2 table-sm table-striped">
          <thead>
            <th>Przedmiot</th>
            <th>j.m.</th>
            <th>ilość</th>
            <th>cena netto</th>
            <th>wartość netto</th>
            <th>wartość brutto</th>
          </thead>
          <tbody>
            <tr v-for="item in offer" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.measure }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.price }}</td>
              <td>{{ (item.amount * item.price).toFixed(2) }}</td>
              <td>{{ (item.amount * item.price * vat).toFixed(2) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><b>Suma PLN:</b></td>
              <td></td>
              <td></td>
              <td v-if="vat == '1.08'"><b>VAT: 8%</b></td>
              <td v-else-if="vat == '1.23'"><b>VAT: 23%</b></td>
              <td>
                <b>{{ netto.toFixed(2) }}</b>
              </td>
              <td>
                <b>{{ brutto.toFixed(2) }}</b>
              </td>
            </tr>
          </tfoot>
        </table>

        <div class="col-12 my-3 text-center">
          <img class="img-fluid" style="max-height: 350px" :src="`${imageUrl}`" alt="" />
        </div>

        <div class="col-6 my-5 text-center">
          <small>Uwagi do oferty:</small> <br />
          <div v-html="notice"></div>
        </div>
        <div class="col-6 my-5 text-center">
          <small>Wykonawca F.H.U KLIM-BUD:</small> <br />
          {{ user.name }} <br />
          {{ user.phoneNumber }}
        </div>
      </div>
    </div>
    </div>

    <!-- Fixed footer -->
    <div class="modal-footer-custom">
      <div class="footer-left">
        <button class="btn-cancel" @click="$emit('closeModal')">
          ← Anuluj
        </button>
      </div>
      <div class="footer-center">
        <button class="btn-save" @click="saveOfferOnly()">
          <span class="submit-icon">💾</span>
          Zapisz ofertę
        </button>
        <button class="btn-submit" @click="generateOffer(offer)">
          <span class="submit-icon">📄</span>
          Generuj PDF
        </button>
      </div>
      <div class="footer-right"></div>
    </div>
  </modal>
</template>
<script>
import html2pdf from "html2pdf.js";
export default {
  props: [
    "offer",
    "vat",
    "netto",
    "brutto",
    "imageUrl",
    "offerHeader",
    "header",
    "notice",
    "user",
    "header2",
    "subheader",
    "offerNumber",
    "number",
    "duplicatedContractor",
  ],
  data() {
    return {
      date: new Date(),
      showClientForm: false,
      needPdfFilename: false,
      clientData: {
        nameOrEmail: '',
        pdfFilename: ''
      },
      pendingAction: null, // 'save' lub 'generate'
    };
  },
  methods: {
    openClientForm(action) {
      this.pendingAction = action;
      this.needPdfFilename = (action === 'generate');
      this.clientData = {
        nameOrEmail: this.duplicatedContractor || '',
        pdfFilename: ''
      };
      this.showClientForm = true;
      
      // Focus na pierwsze pole po otwarciu (jeśli nie jest wypełnione)
      this.$nextTick(() => {
        if (this.$refs.clientNameInput) {
          if (!this.clientData.nameOrEmail) {
            this.$refs.clientNameInput.focus();
          }
        }
      });
    },
    cancelClientForm() {
      this.showClientForm = false;
      this.pendingAction = null;
      this.clientData = {
        nameOrEmail: '',
        pdfFilename: ''
      };
    },
    submitClientForm() {
      // Walidacja nazwy klienta
      if (!this.clientData.nameOrEmail || this.clientData.nameOrEmail.trim() === '') {
        alert("Musisz podać nazwę klienta lub email!");
        return;
      }

      // Walidacja nazwy pliku PDF dla generowania
      if (this.needPdfFilename && (!this.clientData.pdfFilename || this.clientData.pdfFilename.trim() === '')) {
        alert("Musisz podać nazwę pliku PDF!");
        return;
      }

      // Zamknij modal
      this.showClientForm = false;

      // Wykonaj odpowiednią akcję
      if (this.pendingAction === 'save') {
        this.executeSaveOffer();
      } else if (this.pendingAction === 'generate') {
        this.executeGenerateOffer();
      }
    },
    saveOfferOnly() {
      // Walidacja - sprawdź czy są jakieś pozycje w ofercie
      if (!this.offer || this.offer.length === 0) {
        alert("Dodaj przynajmniej jedną pozycję do oferty!");
        return;
      }

      // Sprawdź czy counter jest dostępny
      if (!this.number || this.number === 0) {
        alert("Błąd: nie można wygenerować numeru oferty. Odśwież stronę i spróbuj ponownie.");
        return;
      }

      // Otwórz modal z formularzem
      this.openClientForm('save');
    },
    executeSaveOffer() {
      const contractorInfo = this.clientData.nameOrEmail;
      
      console.log("Zapisywanie oferty z numerem countera:", this.number);
      
      this.$store.dispatch("createOffer", {
        contractor: contractorInfo,
        date: this.date,
        offer: this.offer,
        vat: this.vat,
        netto: this.netto,
        brutto: this.brutto,
        imageUrl: this.imageUrl,
        offerHeader: this.offerHeader,
        header: this.header,
        notice: this.notice,
        user: this.user,
        header2: this.header2,
        subheader: this.subheader,
        offerNumber: this.offerNumber,
      }).then(() => {
        console.log("Oferta zapisana, aktualizuję counter z", this.number, "na", this.number + 1);
        return this.$store.dispatch("updateCounter", this.number);
      }).then(() => {
        alert("Oferta została zapisana! Numer: " + this.offerNumber);
        this.$emit("closeModal");
      }).catch((error) => {
        console.error("Błąd zapisywania oferty:", error);
        alert("Wystąpił błąd podczas zapisywania oferty: " + error.message);
      });
    },
    generateOffer() {
      // Walidacja - sprawdź czy są jakieś pozycje w ofercie
      if (!this.offer || this.offer.length === 0) {
        alert("Dodaj przynajmniej jedną pozycję do oferty!");
        return;
      }

      // Sprawdź czy counter jest dostępny
      if (!this.number || this.number === 0) {
        alert("Błąd: nie można wygenerować numeru oferty. Odśwież stronę i spróbuj ponownie.");
        return;
      }

      // Otwórz modal z formularzem (z polem na nazwę pliku PDF)
      this.openClientForm('generate');
    },
    executeGenerateOffer() {
      const contractorInfo = this.clientData.nameOrEmail;
      const filename = this.clientData.pdfFilename;
      
      var element = document.getElementById("toPrint");
      html2pdf(element, {
        margin: 0.1,
        filename: filename,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { dpi: 192 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });

      // Zapisz ofertę z podaną nazwą kontrahenta
      this.addOffer(contractorInfo);
    },
    addOffer(contractorName) {
      // Jeśli nie przekazano nazwy, zapytaj
      let name = contractorName;
      if (!name) {
        name = prompt("Nazwa klienta/Adres Email");
        if (!name) {
          name = "brak informacji";
        }
      }
      
      console.log("Zapisywanie oferty (z PDF) z numerem countera:", this.number);
      
      this.$store.dispatch("createOffer", {
        contractor: name,
        date: this.date,
        offer: this.offer,
        vat: this.vat,
        netto: this.netto,
        brutto: this.brutto,
        imageUrl: this.imageUrl,
        offerHeader: this.offerHeader,
        header: this.header,
        notice: this.notice,
        user: this.user,
        header2: this.header2,
        subheader: this.subheader,
        offerNumber: this.offerNumber,
      }).then(() => {
        console.log("Oferta zapisana, aktualizuję counter z", this.number, "na", this.number + 1);
        return this.$store.dispatch("updateCounter", this.number);
      }).then(() => {
        this.$emit("closeModal");
      }).catch((error) => {
        console.error("Błąd zapisywania oferty:", error);
        alert("Wystąpił błąd podczas zapisywania oferty: " + error.message);
      });
    },
  },
};
</script>

<style scoped>
/* --- Nagłówek modalu --- */
.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 30px 40px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.header-content {
  flex: 1;
}

.modal-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: white;
}

.modal-subtitle {
  margin: 6px 0 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* --- Zawartość modalu --- */
.modal-content-custom {
  padding: 40px;
  margin-bottom: 100px;
  background: white;
}

/* --- Sekcja PDF --- */
#toPrint {
  background: white;
  padding: 30px;
}

/* --- Fixed footer --- */
.modal-footer-custom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 40px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}

.footer-left {
  flex: 1;
}

.footer-center {
  display: flex;
  gap: 15px;
  align-items: center;
}

.footer-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.btn-save {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4);
}

.btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(40, 167, 69, 0.5);
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

.submit-icon {
  font-size: 18px;
}

.btn-cancel {
  background: transparent;
  color: #718096;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  color: #2d3748;
  background: #f7fafc;
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 20px 25px;
  }

  .modal-title {
    font-size: 22px;
  }

  .modal-content-custom {
    padding: 25px 20px;
  }

  #toPrint {
    padding: 20px;
  }

  .modal-footer-custom {
    flex-direction: column;
    padding: 15px 20px;
    gap: 10px;
  }

  .footer-left,
  .footer-right {
    display: none;
  }

  .footer-center {
    flex-direction: column;
    width: 100%;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }
}

/* --- Modal formularza klienta --- */
.client-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.client-form-modal {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.client-form-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px 30px;
  border-radius: 16px 16px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.client-form-header h4 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.btn-close-form {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close-form:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

.client-form-body {
  padding: 30px;
}

.form-field {
  margin-bottom: 20px;
}

.form-field label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.form-field input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-field input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.client-form-footer {
  padding: 20px 30px 30px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-form-cancel {
  padding: 12px 24px;
  background: #f7fafc;
  color: #718096;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-form-cancel:hover {
  background: #edf2f7;
  color: #2d3748;
}

.btn-form-submit {
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-form-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

@media (max-width: 768px) {
  .client-form-modal {
    width: 95%;
    margin: 20px;
  }

  .client-form-body {
    padding: 20px;
  }

  .client-form-footer {
    flex-direction: column-reverse;
  }

  .btn-form-cancel,
  .btn-form-submit {
    width: 100%;
    text-align: center;
  }
}
</style>
